module.exports = __webpack_public_path__ + "static/media/Parth_Yewale.82df6d86.jpg";